import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import GraphHoverCardCollapsedSelfieImage from 'dashboard/components/GraphHoverCardCollapsedSelfieImage';
import { UppercaseLabel } from 'dashboard/components/Typography';
import { HydratedAccountSimilaritySelfie, SelfieFile } from 'dashboard/models/graph-hydration';
import {
  ACCOUNT_SIMILARITY_SELFIE_DATUM_TYPE,
  DATUM_TYPE_DISPLAY_NAMES,
} from 'lib/constants/graph';

const SectionTitle = styled(UppercaseLabel)`
  color: ${Color.CoreSlate900};
`;

const Spacer = styled.div`
  height: ${Spacing[4]};
`;

const Container = styled.div`
  display: flex;
  margin-left: ${Spacing[4]};
`;

const MoreImageIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: ${Color.BackgroundLabelGrey};
  margin-left: -${Spacing[4]};
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border: white solid 2px;
`;

interface GraphHoverCardAccountSimilaritySelfieCollapsedProps {
  hydratedAccountSimilaritySelfies: HydratedAccountSimilaritySelfie[];
}

const GraphHoverCardAccountSimilaritySelfieCollapsed = ({
  hydratedAccountSimilaritySelfies,
}: GraphHoverCardAccountSimilaritySelfieCollapsedProps) => {
  const serverHydratedAccountSimilaritySelfies: SelfieFile[][] = [];
  const selfiesIdAdded: Set<string> = new Set();

  hydratedAccountSimilaritySelfies.forEach((selfie) => {
    const {
      account1: { id: account1Id, selfies: account1Selfies },
      account2: { id: account2Id, selfies: account2Selfies },
    } = selfie.hydrationData;

    if (!selfiesIdAdded.has(account1Id) && account1Selfies && account1Selfies.length) {
      serverHydratedAccountSimilaritySelfies.push(account1Selfies);
      selfiesIdAdded.add(account1Id);
    }
    if (!selfiesIdAdded.has(account2Id) && account2Selfies && account2Selfies.length) {
      serverHydratedAccountSimilaritySelfies.push(account2Selfies);
      selfiesIdAdded.add(account2Id);
    }
  });

  return (
    <>
      <SectionTitle>
        {DATUM_TYPE_DISPLAY_NAMES[ACCOUNT_SIMILARITY_SELFIE_DATUM_TYPE.token]}
      </SectionTitle>
      <Spacer />
      <Container>
        {serverHydratedAccountSimilaritySelfies.slice(0, 4).map((selfie) => {
          const key = 'token' in selfie[0] ? selfie[0].token : selfie[0].id + selfie[0].filename;
          return (
            <GraphHoverCardCollapsedSelfieImage
              data-test='graph-hover-card-collapsed-selfie-image'
              key={key}
              selfieFile={selfie[0]}
            />
          );
        })}
        {serverHydratedAccountSimilaritySelfies.length > 4 ? (
          <MoreImageIcon>{serverHydratedAccountSimilaritySelfies.length - 4}+</MoreImageIcon>
        ) : null}
      </Container>
    </>
  );
};

export default GraphHoverCardAccountSimilaritySelfieCollapsed;
